import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/certification/_list/settings/")({
  beforeLoad: () => {
    throw redirect({
      to: "/certification/settings/issuing-organization",
    });
  },
});
